module.exports = "<div class=\"container\">\r\n  <div class=\"row text-center\">\r\n    <ul id=\"progressbar\" class=\"col-xs-12\">\r\n      <li *ngFor=\"let step of steps\" [class.active]=\"currentStep >= step.stepNumber\" [class.current]=\"currentStep == step.stepNumber\" >\r\n        {{ step.name }}\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/step-indicator/step-indicator.component.html
// module id = ./src/app/layout/step-indicator/step-indicator.component.html
// module chunks = main